// Light/dark design tokens for the public EzeitPro website (Home + shared showcase components).
// Home.jsx used to hold this inline; the new ScreenshotFrame / ModuleShowcase components take the
// same object as a `d` prop so they match the page they are dropped into.

// Dark mode is deep navy, taken from the hero gradient, so the blue runs top to bottom instead of
// sitting on black. Every website page builds its dark palette from this one object.
export const NAVY = {
  bg: '#0F1A33',        // page
  bgAlt: '#13213F',     // alternate sections
  surface: '#1A2A4D',   // cards, panels, header bars
  surfaceUp: '#213461', // raised cards
  footBg: '#0B1428',    // footer, darkest navy
  navBg: 'rgba(15,26,51,0.94)',
  text: '#E8ECF5', textSec: '#A9B4CC', textMuted: '#7C89A6',
  border: 'rgba(255,255,255,0.09)', borderMd: 'rgba(255,255,255,0.16)',
  shadowInk: 'rgba(3,8,20,', // + opacity + ')'
  heroBg: 'linear-gradient(135deg,#1a0a2e 0%,#16213e 50%,#0f3460 100%)',
  ctaBg: 'linear-gradient(135deg,#1a0a2e,#16213e)',
};

export function websiteTokens(isDark) {
  return isDark ? {
    bg: NAVY.bg, bgAlt: NAVY.bgAlt, surface: NAVY.surface, surfaceUp: NAVY.surfaceUp,
    primary: '#E91E63', primaryLight: '#F48FB1', primaryCont: 'rgba(233,30,99,0.15)',
    onPrimary: '#FFF', text: NAVY.text, textSec: NAVY.textSec, textMuted: NAVY.textMuted,
    border: NAVY.border, borderMd: NAVY.borderMd,
    sh1: `0 1px 3px ${NAVY.shadowInk}0.8)`, sh2: `0 2px 8px ${NAVY.shadowInk}0.7)`,
    sh4: `0 4px 16px ${NAVY.shadowInk}0.6)`, sh8: `0 8px 32px ${NAVY.shadowInk}0.55)`,
    navBg: NAVY.navBg,
    heroBg: NAVY.heroBg,
    ctaBg: NAVY.ctaBg,
    footBg: NAVY.footBg,
    chipBg: 'rgba(233,30,99,0.18)', chipText: '#F48FB1',
    greenBg: 'rgba(76,175,80,0.15)', greenText: '#81C784',
    statBg: NAVY.bgAlt,
  } : {
    bg: '#FAFAFA', bgAlt: '#F5F5F5', surface: '#FFFFFF', surfaceUp: '#FFFFFF',
    primary: '#C2185B', primaryLight: '#E91E63', primaryCont: '#FCE4EC',
    onPrimary: '#FFF', text: '#212121', textSec: '#424242', textMuted: '#757575',
    border: 'rgba(0,0,0,0.08)', borderMd: 'rgba(0,0,0,0.14)',
    sh1: '0 1px 3px rgba(0,0,0,0.1)', sh2: '0 2px 8px rgba(0,0,0,0.08)',
    sh4: '0 4px 16px rgba(0,0,0,0.08)', sh8: '0 8px 32px rgba(0,0,0,0.1)',
    navBg: 'rgba(255,255,255,0.96)',
    heroBg: 'linear-gradient(135deg,#fce4ec 0%,#fafafa 50%,#ede7f6 100%)',
    ctaBg: 'linear-gradient(135deg,#FCE4EC,#F3E5F5)',
    footBg: '#212121',
    chipBg: '#FCE4EC', chipText: '#C2185B',
    greenBg: '#E8F5E9', greenText: '#2E7D32',
    statBg: '#FFFFFF',
  };
}
